import Link, { SIZES } from './Link';
export { SIZES };
export default Link;
